import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const getSuggestedBinsForFulfillmentGroup = {
  name: "getSuggestedBinsForFulfillmentGroup" as const,
  input: z.object({
    fulfillmentGroupId: z.string(),
    excludeWorkOrderId: z.string(),
  }),
  output: z.object({
    bins: z.array(
      z.object({ id: storageLocationIdFormat.schema, name: z.string() }),
    ),
  }),
};
